import type { Locale } from 'date-fns';
import { enUS } from 'date-fns/locale/en-US';
import { es } from 'date-fns/locale/es';
import { pt } from 'date-fns/locale/pt';

const LOCALE_BY_LANGUAGE: Record<string, Locale> = {
  en: enUS,
  es,
  pt,
};

/** Matches the primary subtag, so `es-MX` formats in Spanish; anything unregistered is English. */
export function resolveDateFnsLocale(language: string | undefined): Locale {
  const primary = language?.split('-')[0]?.toLowerCase();
  return (primary ? LOCALE_BY_LANGUAGE[primary] : undefined) ?? enUS;
}
